import View from './View';
import Container from './Container';

export default Container(View);
